<template>
  <v-container fluid>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="2"
        class="pt-1"
      >
        <inventory-class-select-element
          v-model="inventoryClassId"
          :hide-details="true"
          :is-state="true"
        />
      </v-col>

      <v-col
        v-if="windowWidth > 1500"
        class="pt-1 pr-0"
        cols="2"
      >
        <v-autocomplete
          v-model="filterJob"
          label="Job"
          :items="jobs"
          hide-details="true"
          :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
          item-value="id"
          clearable
          :single-select="false"
          :loading="loadingJobs"
        >
          <template #selection="{ item }">
            <v-chip
              v-if="item && item.sub_class_name"
              small
              :color="item.sub_class.color"
              text-color="white"
              class="mr-2"
            >
              {{ item.sub_class_name }}
            </v-chip>
            <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span></span>
          </template>
          <template #item="{ item }">
            <v-chip
              v-if="item && (item.sub_class_color || item.sub_class_name)"
              small
              :color="item.sub_class_color"
              text-color="white"
              class="mr-2"
            >
              {{ item.sub_class_name }}
            </v-chip>
            <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span></span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row align="center">
      <v-col
        v-for="tab, idx in tabs"
        :key="idx"
        cols="auto"
        :style="`cursor: pointer; border-bottom: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? '2px solid #1976d2' : 'none'};`"
        class="ml-2 mr-2"
        @click="tabChange(tab)"
      >
        <span :style="`font-size: 16px !important; color: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? '#1976d2' : isDarkMode ? '' : 'rgba(0,0,0,0.8)'}; font-weight: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? 'bold' : 'normal'};`">{{ tab.name }}</span>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-menu
          v-model="filterMenu"
          transition="scale-transition"
          offset-y
          min-width="500"
          nudge-left="50"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="success"
              outlined
              v-bind="attrs"
              v-on="on"
              @click="filterMenu = !filterMenu"
            >
              <v-icon
                small
                class="mr-1"
              >
                mdi-filter
              </v-icon>
              FILTERS
            </v-btn>
          </template>
          <v-card
            class="pa-8"
          >
            <v-row>
              <v-col>
                <v-row>
                  <v-col>
                    <span style="font-size: 22px !important; font-weight: bold;">Filters</span>
                  </v-col>
                  <v-col class="text-end pr-1">
                    <v-btn
                      icon
                      :style="{color: isDarkMode ? '' : '#000000'}"
                      @click="filterMenu = !filterMenu"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col>
                    <v-menu
                      ref="menuShipDate"
                      v-model="dateMenuShipDate"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterPlannedShipDate"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuShipDate.save(filterPlannedShipDate)"
                        >
                          <template slot="label">
                            Plan Ship Date From
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterPlannedShipDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterPlannedShipDate = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuShipDateEnd"
                      v-model="dateMenuShipDateEnd"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterPlannedShipDateEnd"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuShipDateEnd.save(filterPlannedShipDateEnd)"
                        >
                          <template slot="label">
                            Plan Ship Date To
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterPlannedShipDateEnd"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterPlannedShipDateEnd = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuProductionCompletionDate"
                      v-model="dateMenuProductionCompletionDate"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterProductionCompletionDate"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuProductionCompletionDate.save(filterProductionCompletionDate)"
                        >
                          <template slot="label">
                            Production Completion Date From
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterProductionCompletionDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterProductionCompletionDate = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuProductionCompletionDateEnd"
                      v-model="dateMenuProductionCompletionDateEnd"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterProductionCompletionDateEnd"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuProductionCompletionDateEnd.save(filterProductionCompletionDateEnd)"
                        >
                          <template slot="label">
                            Production Completion Date To
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterProductionCompletionDateEnd"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterProductionCompletionDateEnd = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col />
                </v-row>
                <v-row>
                  <v-spacer />
                  <v-col
                    cols="auto"
                    class="pr-0"
                  >
                    <v-btn
                      color="normal"
                      @click="filterMenu = !filterMenu"
                    >
                      <span style="font-size: 14px !important;">Close</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      @click="clearAllFilters"
                    >
                      Clear
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-menu
          offset-y
          min-width="400"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="orange"
              outlined
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                style="font-size: 20px;"
                class="pr-1"
              >
                mdi-cog
              </v-icon> MORE OPTIONS
            </v-btn>
          </template>
          <v-card>
            <div class="d-flex flex-column ga-4 pa-6">
              <div
                v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin))"
                :disabled="!selectedItems || selectedItems.length === 0"

                class="options-item-div"
                @click="archiveAll()"
              >
                <v-icon style="color: #0D9488;">
                  mdi-archive-outline
                </v-icon>
                <span style="color: #0D9488; font-weight: 600; font-size: 16px !important">{{ status == 1 ? 'ARCHIVE' : 'RESTORE' }}</span>
              </div>
              <!-- <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" /> -->
              <!-- <div
                :disabled="selectedItems.length === 0"
                class="options-item-div"
                @click="openPlannedShipDateMultipleForm()"
              >
                <v-icon :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0891B2'};`">
                  mdi-truck-delivery-outline
                </v-icon>
                <span :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0891B2'}; font-weight: 600; font-size: 16px !important`">CHANGE PLAN SHIP DATE</span>
              </div> -->
              <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" />
              <div
                style="width: 100%;"
                class="d-flex flex-column ga-4"
              >
                <div
                  class="d-flex align-center justify-space-between"
                >
                  <div class="options-item-div">
                    <div class="d-flex flex-column ">
                      <span style="font-size: 16px !important; color: #000; font-weight: 500;">View Mode - {{ isShowStages ? 'Show' : 'Hide' }} Stages</span>
                      <span style="font-size: 14px !important;">Toggle between Show and Hide stages </span>
                    </div>
                  </div>
                  <v-switch
                    v-model="isShowStages"
                    hide-details
                    class="mt-0"
                    @click.stop
                  />
                </div>
              </div>
            </div>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin))"
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-btn
          color="primary"
          outlined
          @click="open()"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Record
        </v-btn>
      </v-col>
      <v-col
        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin)) && status == statusIdOnHand"
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-btn
          color="purple"
          outlined
          @click="importRailingPanels()"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          RAILINGS IMPORT
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="pa-1"
      >
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            fixed-header
            :loading="loading"
            dense
            :height="windowHeight"
            :server-items-length="totalItems"
            @update:options="updateOptions"
          >
            <template
              v-for="h in headers"
              #[`header.${h.value}`]="{ header }"
            >
              <v-tooltip
                :key="h.value"
                top
              >
                <template #activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>
                <span>{{ header.fullText }}</span>
              </v-tooltip>
            </template>
            <template #item="{ item }">
              <tr>
                <td
                  v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin))"
                  class="pl-1 pr-1"
                >
                  <v-checkbox
                    v-model="selectedItems"
                    :disabled="status == statusIdOnHand && selectedItems.length >= 1 && !selectedItems.includes(item)"
                    :value="item"
                    class="mt-0 mb-0 pt-0"
                    hide-details
                  />
                </td>
                <td class="pl-1 pr-1 text-center">
                  <v-chip
                    small
                    :color="item && item.class ? item.class.color : 'grey'"
                    text-color="white"
                  >
                    {{ item && item.class ? item.class.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1">
                  <span><text-highlight :queries="search">{{ item.location ? formatLocation(item.location.name) : '' }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    top
                    color="transparent"
                    style="opacity: 1;"
                  >
                    <template #activator="{ on }">
                      <span
                        v-if="item.is_shipping_complete == 1"
                        :style="{fontWeight: 500, color: (isDarkMode ? 'black' : '#0000000'), borderRadius: '4px', width: 'auto', height: '25px', border: 0, backgroundColor: '#C8E6C9'}"
                        class="pa-1"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>
                      <span
                        v-else-if="item.is_ready_for_shipping == 1"
                        :style="{fontWeight: 500, color: (isDarkMode ? 'black' : '#0000000'), borderRadius: '4px', width: 'auto', height: '25px', border: 0, backgroundColor: '#F8BBD0'}"
                        class="pa-1"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>

                      <span
                        v-else
                        style="font-weight: 500;"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>
                    </template>
                    <v-chip
                      v-if="item && item.sub_class_name"
                      small
                      :color="item.sub_class.color"
                      text-color="white"
                    >
                      {{ item.sub_class_name }}
                    </v-chip>
                  </v-tooltip>
                </td>
                <td class="pl-1 pr-1">
                  <span><text-highlight :queries="search">{{ item.project_floor }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    color="black"
                    top
                  >
                    <template #activator="{ on }">
                      <span v-on="on"><text-highlight
                        :queries="search"
                        v-on="on"
                      >{{ item.wo_number }}</text-highlight></span>
                    </template>
                    <span>{{ item.created_at_po_min }}</span>
                  </v-tooltip>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.wip_panel_quantity }}</text-highlight></span>
                </td>
                <template v-if="isShowStages">
                  <td
                    v-for="stage in stages"
                    :key="stage.statusId"
                  >
                    <v-btn
                      v-if="stage.statusId != null"
                      elevation="0"
                      fab
                      outlined
                      tile
                      color="#FFD84D"
                      :class="`box ${getStageClass(item, stage)}`"
                      @click="openItemsForm(item, stage.statusId)"
                    >
                      <span>{{ getStageValue(item, stage) }}</span>
                    </v-btn>
                    <div
                      v-else
                      class="pl-1"
                      style="width: 1px; height: 100%; border-right: 1px solid #E0E0E0;"
                    />
                  </td>
                </template>
                <td class="pl-1 pr-1 text-center">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin) ? openProductionCompletionDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.production_completion_date_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0 text-center">
                  <v-icon
                    v-if="item.production_completion_date_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.production_completion_date_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>
                <!-- <td class="pl-1 pr-1 text-center">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin) ? openPlannedShipDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.planned_ship_date_short }}</text-highlight></a>
                </td> -->
                <!-- <td class="pl-0 pr-0 text-center">
                  <v-icon
                    v-if="item.ship_date_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.ship_date_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td> -->
                <!-- <td class="pl-1 pr-1">
                  <text-highlight :queries="search">{{ item.ship_to_location ? item.ship_to_location.name : '-' }}</text-highlight>
                </td> -->
                <td
                  class="pl-1 pr-1 text-center"
                >
                  <v-chip
                    v-if="item.delay_reason"
                    small
                    :color="item && item.delay_reason ? item.delay_reason.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.delay_reason ? item.delay_reason.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1 text-center">
                  <v-tooltip
                    v-if="item.last_note"
                    top
                    color="black"
                  >
                    <template #activator="{ on }">
                      <span
                        style="white-space: nowrap; color: rgb(255, 152, 0);"
                        v-on="on"
                      >
                        <v-btn
                          v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin) || roles.includes(userRoleIdPanelSupervisor)"
                          icon
                          small
                          @click="openNotes(item)"
                        >
                          <v-icon
                            small
                          >
                            mdi-eye
                          </v-icon>
                        </v-btn>
                        <!-- <text-highlight
                          :queries="search"
                        >{{ item.last_note_short }}</text-highlight> -->
                      </span>
                    </template>
                    <span>{{ item.last_note }}</span>
                  </v-tooltip>
                </td>
                <td class="pl-1 pr-1">
                  <v-chip
                    small
                    style="width: 100%; max-width: 140px; white-space: nowrap; "
                    :color="item && item.wip_panel_grouped_status ? item.wip_panel_grouped_status.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.wip_panel_grouped_status ? item.wip_panel_grouped_status.name : '' }}
                  </v-chip>
                </td>
                <td
                  id="cellOverflow"
                  :class="(isDarkMode ? 'theme--dark ' : '') + 'pl-0 pr-0 text-end'"
                >
                  <v-btn
                    v-if="renderDoneButton(item)"
                    class="ml-1 mr-3 mt-1 mb-1 elevation-0"
                    color="#0BDE79"
                    small
                    @click="toggle(item.id, item.status_id)"
                  >
                    <span style="color: white;">DONE</span>
                  </v-btn>
                  <v-btn
                    v-else-if="item.status_id === statusIdCompleted && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin))"
                    class="ml-1 mr-3 mt-1 mb-1 elevation-0"
                    color="#0BDE79"
                    small
                    @click="toggle(item.id, item.status_id)"
                  >
                    <span style="color: white;">RESTORE</span>
                  </v-btn>
                  <v-menu
                    v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin))"
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1 mr-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        v-if="(item.status_id == statusIdInProgress || item.status_id == statusIdOnHand) && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin))"
                        @click="openEdit(item)"
                      >
                        <v-list-item-title style="color: #1976d2; font-weight: 600;">
                          EDIT
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title style="color: #ff5252; font-weight: 600;">
                          DELETE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin) || roles.includes(userRoleIdPanelSupervisor)"
                        @click="openNotes(item)"
                      >
                        <v-list-item-title style="color: #ff9800; font-weight: 600;">
                          NOTES {{ item.notes ? `(${item.notes.length})` : '' }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="toggle(item.id, item.status_id, true)"
                      >
                        <v-list-item-title style="color: purple; font-weight: 600;">
                          ARCHIVE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="delay(item)"
                      >
                        <v-list-item-title style="color: #00695C; font-weight: 600;">
                          DELAY
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <v-menu
                    v-else
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1 mr-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        v-if="(item.status_id == statusIdInProgress || item.status_id == statusIdOnHand) && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin))"
                        @click="openEdit(item)"
                      >
                        <v-list-item-title style="color: #1976d2; font-weight: 600;">
                          EDIT
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title style="color: #ff5252; font-weight: 600;">
                          DELETE
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu> -->
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogProductionCompletionDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <v-date-picker
                v-model="selectedItem.production_completion_date"
                no-title
                scrollable
                :min="weekdayAfterToday"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="dialogProductionCompletionDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="updateProductionCompletionDate(selectedItem.id, selectedItem.production_completion_date, selectedItem.production_completion_time); dialogProductionCompletionDate = false"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProductionCompletionDateMultiple"
      max-width="350px"
    >
      <v-card>
        <v-card-text class="pt-6">
          <v-date-picker
            v-model="productionCompletionDateMultiple"
            :min="weekdayAfterToday"
            no-title
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="dialogProductionCompletionDateMultiple = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="updateProductionCompletionDateMultiple(); dialogProductionCompletionDateMultiple = false"
            >
              Apply
            </v-btn>
          </v-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <v-dialog
      v-model="dialogPlannedDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <v-date-picker
                v-model="selectedItem.planned_ship_date"
                no-title
                scrollable
                :min="weekdayAfterTomorrow"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="dialogPlannedDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="updatePlannedShipDate(selectedItem.id, selectedItem.planned_ship_date, selectedItem.planned_ship_time); dialogPlannedDate = false"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPlannedShipDateMultiple"
      max-width="500px"
      min-width="500px"
    >
      <v-card style="min-width: 500px;">
        <v-card-title>
          Select Job Location to move to Current
        </v-card-title>
        <v-card-text>
          <v-form ref="formJob">
            <v-autocomplete
              v-model="selectedLocationId"
              :items="locations"
              item-text="name"
              item-value="id"
              :rules="[(v) => !!v || 'Job Location is required']"
              clearable
              class="mb-3"
            >
              <template slot="label">
                Job Location<RedAsterisk />
              </template>
            </v-autocomplete>
          </v-form>
          <v-date-picker
            v-model="plannedShipDateMultiple"
            no-title
            scrollable
            :min="weekdayAfterTomorrow"
            :allowed-dates="allowedDates"
            width="100%"
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="dialogPlannedShipDateMultiple = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="updatePlannedShipDateMultiple();"
            >
              Apply
            </v-btn>
          </v-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog> -->
    <wip-panel-schedule-form
      ref="wipPanelForm"
      @success="get()"
    />
    <note-form v-show="false" ref="noteForm" @success="get()" />
    <wip-panel-schedule-history-form
      ref="historyForm"
      @success="get()"
    />
    <wip-panel-schedule-item-form
      ref="wipPanelScheduleItemForm"
    />
    <wip-panel-schedule-delay-reason-form
      ref="delayReasonForm"
      @success="get()"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import WipPanelScheduleForm from '@/components/forms/wipPanelSchedules/WipPanelScheduleForm';
import WipPanelScheduleHistoryForm from '@/components/forms/wipPanelSchedules/WipPanelScheduleHistoryForm';
import * as FormatHelpers from '@/helpers/FormatHelpers';
import moment from 'moment';
import { addWeekdaysMoment, subtractWeekdaysMoment } from '@/helpers/DateHelpers';
import { saveAs } from 'file-saver';
import WipPanelScheduleDelayReasonForm from '@/components/forms/wipPanelSchedules/WipPanelScheduleDelayReasonForm.vue';
import WipPanelScheduleItemForm from '@/components/forms/wipPanelSchedules/WipPanelScheduleItemForm.vue';
import NoteForm from '@/components/forms/notes/NoteForm';

export default {
  components: {
    WipPanelScheduleForm,
    WipPanelScheduleHistoryForm,
    WipPanelScheduleDelayReasonForm,
    WipPanelScheduleItemForm,
    NoteForm
  },
  props: {

  },
  data: () => ({
    items: [],
    totalItems: 0,
    allItems: [],
    loading: false,
    filterJob: null,
    filterStage: null,
    filterGlassReqBy: null,
    // filterPlannedShipDate: null,
    // filterPlannedShipDateEnd: null,
    filterProductionCompletionDate: null,
    filterProductionCompletionDateEnd: null,
    filterLocationId: null,
    filterJobSubClass: null,
    filterRecordType: null,
    dateMenu: false,
    inventoryClassId: null,
    jobs: [],
    footer: {
      'items-per-page-options': [20, 50, 100, 500, 1000],
    },
    statusIdInProgress: 1,
    statusIdCompleted: 2,
    statusIdOnHand: 3,
    noteStatusIdShort: 2,
    noteStatusIdZero: 3,
    materialAvailableId: 1,
    cutId: 2,
    assembleId: 3,
    spandrelId: 4,
    panelsId: 5,
    tAndBId: 6,
    glazedId: 7,
    ppStartedId: 8,
    ppFinishedId: 9,
    topSpaceHeight: 300,
    windowHeight: 1000,
    windowWidth: 1000,
    status: null,
    pagination: {
      itemsPerPage: 500,
      page: 1,
    },
    sort: {
      order_by_first: 'production_completion_date',
      direction_sort: true,
    },
    tabs: [],
    selectedTab: null,
    filterMenu: false,
    dateMenuRequiredBy: false,
    dateMenuShipDate: false,
    dateMenuShipDateEnd: false,
    dateMenuProductionCompletionDate: false,
    dateMenuProductionCompletionDateEnd: false,
    roles: [],
    locations: [],
    userRoleIdAdmin: 3,
    userRoleIdPanelSupervisor: 37,
    userRoleIdPanelAdmin: 38,
    recordTypes: [{ id: 1, name: 'Default Records' }, { id: 2, name: 'Manual Records' }],
    selectedItems: [],
    dialogProdBacklogSchedule: false,
    selectedShipBacklogItem: null,
    dialogSPGlassNote: false,
    dialogSUGlassNote: false,
    dialogShipDate: false,
    dialogPlannedDate: false,
    dialogProductionCompletionDate: false,
    selectedItem: null,
    noteStatuses: [],
    isShowStages: true,
    typeIdSUItems: 1,
    typeIdSPItems: 2,
    loadingJobs: false,
    loadingPo: false,
    dialogGlassRequiredByDateMultiple: false,
    dialogPlannedShipDateMultiple: false,
    dialogProductionCompletionDateMultiple: false,
    productionCompletionDateMultiple: null,
    glassRequiredByDateMultiple: null,
    plannedShipDateMultiple: null,
    windowAccuracy: null,
    today: new Date().toISOString().substr(0, 10),
    dayAfterTomorrow: new Date(Date.now() + 2 * 86400000).toISOString().substr(0, 10),
    dayAfterFive: new Date(Date.now() + 6 * 86400000).toISOString().substr(0, 10),
    dayAfterSix: new Date(Date.now() + 7 * 86400000).toISOString().substr(0, 10),
    selectedLocationId: null,

    noteTypeIdWipPanelSchedule: 10,
    glassStatusIdNew: 1,
    glassStatusIdInProduction: 2,
    glassStatusIdProduced: 3,
    glassStatusIdCanceled: 4,
    glassStatusIdRemake: 5,
    glassStatusIdShipped: 6,
    glassStatusIdReceived: 7,
    glassStatusIdCutting: 10,
    glassStatusIdTempering: 11,
    glassStatusIdShippedToSite: 12,
    glassStatusIdReceivedOnSite: 13,
    glassStatusIdIssued: 17,
    glassStatusIdPShipped: 8,
    glassStatusIdPReceived: 9,
    glassStatusIdPShippedToSite: 14,
    glassStatusIdPReceivedOnSite: 15,
    glassStatusIdRejected: 16,

    customPanelWorkflow4800: false,
    customPanelWorkflow6000: false,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
      wipPanelScheduleState: (state) => state.wipPanelScheduleState,
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin)
          || this.roles.includes(this.userRoleIdPanelAdmin)
    },
    headers() {
      const headers = [];

      if (this.isAdmin) {
        headers.push({
          text: '', fullText: '', value: 'checkbox', class: 'pl-1 pr-1', width: '3%', sortable: false,
        });
      }

      headers.push({
        text: 'Class', fullText: 'Class', value: 'class', class: 'pl-1 pr-1', width: '5%', align: 'center',
      });
      headers.push({
        text: 'Loc.', fullText: 'Location', value: 'location', class: 'pl-1 pr-1', width: '8%',
      });
      headers.push({
        text: 'Project', fullText: 'Project', value: 'project', class: 'pl-1 pr-1', width: '10%',
      });
      headers.push({
        text: 'Floor', fullText: 'Floor', value: 'project_floor', class: 'pl-1 pr-1', width: '5%',
      });
      headers.push({
        text: 'WO#', fullText: 'WO#', value: 'wo_number', class: 'pl-1 pr-1', width: '6%',
      });

      if (this.isShowStages) {
        headers.push({
          text: 'Panel Qty.', fullText: 'Panel Quantity', value: 'wip_panel_quantity', class: 'pl-1 pr-1', width: '5%', sortable: false,
        });
        headers.push({
          text: 'CUT', fullText: 'Cutting', value: 'is_cut', sortable: false,
        });
        headers.push({
          text: 'PRD', fullText: 'Produced', value: 'is_produced', sortable: false,
        });
        headers.push({
          text: 'SHP', fullText: 'Shipped', value: 'is_shipped', sortable: false,
        });
        headers.push({
          text: 'REC', fullText: 'Received', value: 'is_received', sortable: false,
        });
        headers.push({
          text: '', class: 'pl-1 pr-1', width: '1%', sortable: false,
        });
        headers.push({
          text: 'STS', fullText: 'Shipped to Site', value: 'is_shipped_to_site', sortable: false,
        });
        headers.push({
          text: 'ROS', fullText: 'Received on Site', value: 'is_received_on_site', sortable: false,
        });
      }

      // headers.push({
      //   text: 'Prod. Back', fullText: 'Production Backlog', value: 'production_backlog', class: 'pl-1 pr-1', width: '8%', sortable: false, //this will show the ones in cut status
      // });
      // headers.push({
      //   text: 'Ship. Back', fullText: 'Shipping Backlog', value: 'shipping_backlog', class: 'pl-1 pr-1', width: '8%', sortable: false, //this will show the ones in produced status
      // });
      // headers.push({
      //   text: 'Rec. Back', fullText: 'Received Backlog', value: 'received_backlog', class: 'pl-1 pr-1', width: '8%', sortable: false, //this will show the ones in shipped status
      // });
      headers.push({
        text: 'Prod. Comp. Date', fullText: 'Production Completion Date', value: 'production_completion_date', class: 'pl-1 pr-0', width: '5%', align: 'center',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow', class: 'pl-0 pr-0', width: '2%', sortable: false,
      });
      // headers.push({
      //   text: 'Prod. Acc.', fullText: 'Production Accuracy', value: 'production_accuracy', class: 'pl-1 pr-1', width: '5%',
      // });
      // headers.push({
      //   text: 'Plan. Ship Date', fullText: 'Planned Ship Date', value: 'planned_ship_date', class: 'pl-1 pr-0', width: '5%', align: 'center',
      // });
      // headers.push({
      //   text: '', fullText: '', value: 'arrow', class: 'pl-0 pr-0', width: '2%', sortable: false,
      // });
      // headers.push({
      //   text: 'Ship. To Loc.', fullText: 'Ship To Location', value: 'ship_to_location', class: 'pl-1 pr-0', width: '5%',
      // });
      headers.push({
        text: 'Delay Reason', fullText: 'Delay Reason', value: 'delay_reason', class: 'pl-1 pr-1', width: '8%', sortable: false, align: 'center',
      });
      headers.push({
        text: 'Note', fullText: 'Note', value: 'last_note', class: 'pl-1 pr-1', sortable: false, width: '2%', align: 'center',
      });
      headers.push({
        text: 'Status', fullText: 'Status of WIP Panels Grouped', value: 'status', align: 'center',  width: '5%', class: 'pl-1 pr-1', sortable: false,
      });
      headers.push({
        text: '', value: 'actions', align: 'end', class: 'pl-0 pr-0', sortable: false,
      });

      return headers;
    },
    stages() {
      return [
        { statusId: this.glassStatusIdNew, letter: 'C' },
        { statusId: this.glassStatusIdCutting, letter: 'P' },
        { statusId: this.glassStatusIdProduced, letter: 'S' },
        { statusId: this.glassStatusIdShipped, letter: 'R' },
        { statusId: null, letter: '' },
        { statusId: this.glassStatusIdReceived, letter: 'S' },
        { statusId: this.glassStatusIdShippedToSite, letter: 'R' },
      ];
    },
    weekdayAfterToday() {
      const today = moment().format("YYYY-MM-DD");
      return addWeekdaysMoment(today, 1);
    },
    weekdayAfterTomorrow() {
      const today = moment().format("YYYY-MM-DD");
      return addWeekdaysMoment(today, 2);
    },
  },
  watch: {
    $route(to) {
      this.status = to.params.status;
      // if (this.status === this.statusIdOnHand) {
      //   this.pagination.sortBy = ['po_number'];
      // } else {
      //   this.pagination.sortBy = ['planned_ship_date'];
      // }
    },
    inventoryClassId() {
      this.get();
    },
    filterJob(value) {
      this.storeState('job_id', value);
      this.get();
    },
    filterStage(value) {
      this.storeState('stage', value);
      this.get();
    },
    // filterPlannedShipDate(value) {
    //   this.storeState('planned_ship_date', value);
    //   this.get();
    // },
    // filterPlannedShipDateEnd(value) {
    //   this.storeState('planned_ship_date_end', value);
    //   this.get();
    // },
    filterProductionCompletionDate(value) {
      this.storeState('production_completion_date', value);
      this.get();
    },
    filterProductionCompletionDateEnd(value) {
      this.storeState('production_completion_date_end', value);
      this.get();
    },
    filterLocationId() {
      this.get();
    },
    filterRecordType(value) {
      this.storeState('record_type', value);
      this.get();
    },
    filterJobSubClass() {
      this.get();
    },
    status() {
      this.get();
    },
    pagination() {
      this.get();
    },
    search() {
      this.get();
    },
    // locationTabFilter() {
    //   if (this.locationTabFilter === 0) {
    //     this.filterLocationId = null;
    //     this.get();
    //     return;
    //   }
    //   const location = this.tabLocations[this.locationTabFilter];
    //   if (!location) return;
    //   this.filterLocationId = location.id;
    //   this.get();
    // },
    // isShowStages(value) {
    //   this.storeState('isShowStages', value);
    // },
  },
  created() {
    this.status = this.$route.params.status;
    console.log('STATUS', this.status);
    if (!this.status) {
      return;
    }
    if (this.wipPanelScheduleState) {
      if (this.wipPanelScheduleState.pagination) { this.pagination = this.wipPanelScheduleState.pagination; }
      if (this.wipPanelScheduleState.job_id) { this.filterJob = this.wipPanelScheduleState.job_id; }
      if (this.wipPanelScheduleState.stage) { this.filterStage = this.wipPanelScheduleState.stage; }
      // if (this.wipPanelScheduleState.planned_ship_date) { this.filterPlannedShipDate = this.wipPanelScheduleState.planned_ship_date; }
      // if (this.wipPanelScheduleState.planned_ship_date_end) { this.filterPlannedShipDateEnd = this.wipPanelScheduleState.planned_ship_date_end; }
      if (this.wipPanelScheduleState.production_completion_date) { this.filterProductionCompletionDate = this.wipPanelScheduleState.production_completion_date; }
      if (this.wipPanelScheduleState.production_completion_date_end) { this.filterProductionCompletionDateEnd = this.wipPanelScheduleState.production_completion_date_end; }
      if (this.wipPanelScheduleState.record_type) { this.filterRecordType = this.wipPanelScheduleState.record_type; }
      if (this.wipPanelScheduleState.selectedTab) { this.tabChange(this.wipPanelScheduleState.selectedTab); }
      // if (this.wipPanelScheduleState.isShowStages !== null) { this.isShowStages = this.wipPanelScheduleState.isShowStages; }
    }
    this.roles = this.user.roles.map((x) => x.id);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
    this.windowWidth = window.innerWidth;
    this.getLocations();
    const customPanelWorkflow4800 = '4800 Custom Panel Workflow';
    this.customPanelWorkflow4800 = this.businessRulesGetBoolean(customPanelWorkflow4800);
    const customPanelWorkflow6000 = '6000 Custom Panel Workflow';
    this.customPanelWorkflow6000 = this.businessRulesGetBoolean(customPanelWorkflow6000);
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    const tableWrapper = document.querySelector('.v-data-table__wrapper');
    if (tableWrapper) {
      tableWrapper.addEventListener('scroll', this.checkScroll);
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);

    const tableWrapper = document.querySelector('.v-data-table__wrapper');
    if (tableWrapper) {
      tableWrapper.removeEventListener('scroll', this.checkScroll);
    }
  },
  methods: {
    init() {
      this.getJobs();
      this.getNoteStatuses();
    },

    storeState(property, value) {
      const state = this.wipPanelScheduleState;
      state[property] = value;
      this.$store.commit('storeWipPanelScheduleState', state);
    },

    async get() {
      if (this.inventoryClassId === null) return;
      this.loading = true;
      this.items = [];
      this.totalItems = 0;
      const submitModel = {
        filters: {
          status_id: this.status,
          inventory_class_id: this.inventoryClassId,
          stage: this.filterStage,
          job_id: this.filterJob,
          date: this.filterDate,
          // start_date: this.filterPlannedShipDate,
          // end_date: this.filterPlannedShipDateEnd,
          start_date_production_completion: this.filterProductionCompletionDate,
          end_date_production_completion: this.filterProductionCompletionDateEnd,
          location_id: this.filterLocationId,
          record_type: this.filterRecordType,
          job_sub_class_id: this.filterJobSubClass,
        },
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
      };
      const res = await this.$api.wipPanelSchedule.readData(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.loading = false;
      this.init();
      if (!res || !res.data || res.data.length === 0) {
        this.items = [];
        this.allItems = [];
        this.totalItems = 0;
        return;
      }
      res.data.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.total_new = parseInt(item.total_new, 10);
        // eslint-disable-next-line no-param-reassign
        item.total_cutting = parseInt(item.total_cutting, 10);
        // eslint-disable-next-line no-param-reassign
        item.total_produced = parseInt(item.total_produced, 10);
        // eslint-disable-next-line no-param-reassign
        item.total_shipped = parseInt(item.total_shipped, 10);
        // eslint-disable-next-line no-param-reassign
        item.total_received = parseInt(item.total_received, 10);
        // eslint-disable-next-line no-param-reassign
        item.total_shipped_to_site = parseInt(item.total_shipped_to_site, 10);
        // eslint-disable-next-line no-param-reassign
        item.total_received_on_site = parseInt(item.total_received_on_site, 10);
      });
      this.selectedItems = [];
      this.allItems = res.data;
      this.items = res.data.slice(0, 100);
      this.totalItems = res.total;
    },

    async getJobs() {
      this.loadingJobs = true;
      const submitModel = {
        filters: { inventory_class_id: this.inventoryClassId, is_manual: 0 },
      };
      const res = await this.$api.job.readDDL(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        this.loadingJobs = false;
        return;
      }
      this.jobs = res;
      this.loadingJobs = false;
    },

    async getLocations() {
      this.locations = await this.$api.location.getList();

      const locationId14PrecidioCt = 3
      const locationIdChrislea = 8;
      this.locations = this.locations.filter((x) => x.id === locationIdChrislea || x.id === locationId14PrecidioCt);
      this.tabs.push(...this.locations);
      this.tabs.forEach((x) => {
        // eslint-disable-next-line no-param-reassign
        x.type = 'location';
      });
    },

    async getNoteStatuses() {
      this.noteStatuses = await this.$api.productionScheduleNoteStatus.get();
    },

    openItemsForm(item, statusId) {
      let statusIds = [];
      switch (statusId) {
        case this.glassStatusIdNew || this.glassStatusIdIssued:
          statusIds = [this.glassStatusIdNew, this.glassStatusIdIssued];
          break;
        case this.glassStatusIdCutting:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;
        case this.glassStatusIdTempering:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdProduced:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdShipped:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdShipped, this.glassStatusIdNew, this.glassStatusIdReceived, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdReceived:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdShipped, this.glassStatusIdReceived, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdShippedToSite:
          statusIds = [this.glassStatusIdReceivedOnSite, this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdShipped, this.glassStatusIdReceived, this.glassStatusIdShippedToSite, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdReceivedOnSite:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdShipped, this.glassStatusIdReceived, this.glassStatusIdShippedToSite, this.glassStatusIdReceivedOnSite, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdRejected:
          statusIds = [this.glassStatusIdRejected];
          break;

        default:
          statusIds = [statusId];
          break;
      }
      this.$refs.wipPanelScheduleItemForm.open(item, statusIds);
    },

    //toggles between completed and in-progress
    async toggle(id, statusId, isAchive = false) {
      let title = '';
      if (isAchive) {
        title = 'ARCHIVE';
      } else if (statusId === this.statusIdInProgress) {
        title = 'COMPLETE';
      } else {
        title = 'RESTORE';
      }
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${title} this record?`,
      });
      if (!confirm) return;
      const res = await this.$api.wipPanelSchedule.get(`toggle/${id}/${statusId}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.wipPanelForm.open();
    },

    openManual() {
      this.$refs.manualForm.open();
    },

    openEdit(item) {
      this.$refs.wipPanelForm.open(item.id);
    },

    openNotes(item) {
      this.$refs.noteForm.open(
        item.id,
        this.noteTypeIdWipPanelSchedule,
      );
    },

    openHistory(id) {
      this.$refs.historyForm.open(id);
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.wipPanelSchedule.delete(id);
      this.$bus.$emit('loading');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    importRailingPanels() {
      this.$bus.$emit('showError', 'This feature is coming soon!');
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
      this.windowWidth = window.innerWidth;
    },

    allowedDates(val) {
      const day = new Date(val).getDay();
      return day !== 6;
    },

    clearAllFilters() {
      this.filterJob = null;
      this.filterStage = null;
      this.filterGlassReqBy = null;
      // this.filterPlannedShipDate = null;
      // this.filterPlannedShipDateEnd = null;
      this.filterLocationId = null;
      this.filterRecordType = null;
      this.filterProductionCompletionDate = null;
      this.filterProductionCompletionDateEnd = null;
    },

    // async runWebhook(documentType) {
    //   if (this.inventoryClassId === null) {
    //     this.$bus.$emit('showError', 'Please select an inventory class');
    //     return;
    //   }
    //   this.$bus.$emit('loading');
    //   const MODULE_PRODUCTION_SCHEDULE_ID = 20;
    //   let status = 'Current';
    //   if (this.status === 2) {
    //     status = 'Archived';
    //   }
    //   const submitModel = {
    //     status,
    //     inventory_class_id: this.inventoryClassId,
    //     module_id: MODULE_PRODUCTION_SCHEDULE_ID,
    //     location_id: this.filterLocationId ? this.filterLocationId : 0,
    //     sub_class: this.filterJobSubClass ? this.filterJobSubClass : 0,
    //     is_show_stages: this.isShowStages === true ? 'Yes' : 'No',
    //   };
    //   const res = await this.$api.webhook.store(submitModel, 'run');
    //   if (!res) return;
    //   const pdf = await this.$api.report.download(res.id, documentType);
    //   if (!pdf) {
    //     this.$bus.$emit('showError', 'Report Failed');
    //     return;
    //   }
    //   const now = FormatHelpers.getFileTimestamp();
    //   const fileName = `Report_${res.report_title}_${now}`;
    //   const file = new Blob([pdf], {
    //     type: documentType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel',
    //   });
    //   if (documentType === 'pdf') {
    //     const fileURL = URL.createObjectURL(file);
    //     window.open(fileURL);
    //   }
    //   saveAs(file, fileName);
    //   this.$bus.$emit('loading');
    // },

    // openPlannedShipDateForm(item) {
    //   this.selectedItem = item;
    //   this.dialogPlannedDate = true;
    // },

    // openPlannedShipDateMultipleForm() {
    //   this.plannedShipDateMultiple = null;
    //   this.dialogPlannedShipDateMultiple = true;
    // },

    // async updatePlannedShipDate(id, plannedShipDate, plannedShipTime) {
    //   const res = await this.$api.wipPanelSchedule.update({ id, planned_ship_date: plannedShipDate, planned_ship_time: plannedShipTime }, 'planned-ship-date');
    //   if (!res) {
    //     this.$bus.$emit('showError');
    //     return;
    //   }

    //   // eslint-disable-next-line eqeqeq
    //   if (this.status == this.statusIdOnHand) {
    //     const date = this.subtractWeekdays(new Date(plannedShipDate), 1);

    //     const resProd = this.$api.wipPanelSchedule.update(
    //       { id, production_completion_date: date.toISOString().slice(0, 10) },
    //       'production-completion-date',
    //     );

    //     if (!resProd) {
    //       this.$bus.$emit('showError');
    //       return;
    //     }
    //   }

    //   this.$bus.$emit('showSuccess');
    //   this.get();
    // },

    // async updatePlannedShipDateMultiple() {
    //   const valid = await this.$refs.formJob.validate();
    //   if (!valid) return;
    //   this.$bus.$emit('loading');
    //   const items = [];
    //   this.selectedItems.forEach((x) => {
    //     items.push(this.$api.wipPanelSchedule.update({ id: x.id, planned_ship_date: this.plannedShipDateMultiple, location_id: this.selectedLocationId }, 'planned-ship-date'));
    //   });
    //   const itemsRes = await Promise.all(items);
    //   this.$bus.$emit('loading');
    //   if (itemsRes.includes(false)) {
    //     this.$bus.$emit('showError');
    //     return;
    //   }

    //   // eslint-disable-next-line eqeqeq
    //   if (this.status == this.statusIdOnHand) {
    //     const dateProduction = this.subtractWeekdays(new Date(this.plannedShipDateMultiple), 1);

    //     const productions = [];
    //     this.selectedItems.forEach((x) => {
    //       productions.push(
    //         this.$api.wipPanelSchedule.update(
    //           { id: x.id, production_completion_date: dateProduction.toISOString().slice(0, 10) },
    //           'production-completion-date',
    //         ),
    //       );
    //     });

    //     const productionsRes = await Promise.all(productions);

    //     if (productionsRes.includes(false)) {
    //       this.$bus.$emit('showError');
    //       return;
    //     }
    //   }

    //   this.$bus.$emit('showSuccess');
    //   this.dialogPlannedShipDateMultiple = false;
    //   this.get();
    // },

    openProductionCompletionDateForm(item) {
      this.selectedItem = item;
      this.dialogProductionCompletionDate = true;
    },

    openProductionCompletionDateMultipleForm() {
      this.productionCompletionDateMultiple = null;
      this.dialogProductionCompletionDateMultiple = true;
    },

    async updateProductionCompletionDate(id, productionCompletionDate, productionCompletionTime) {
      const res = await this.$api.wipPanelSchedule.update({ id, production_completion_date: productionCompletionDate, production_completion_time: productionCompletionTime }, 'production-completion-date');
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async updateProductionCompletionDateMultiple() {
      this.$bus.$emit('loading');
      const items = [];
      this.selectedItems.forEach((x) => {
        items.push(this.$api.wipPanelSchedule.update({ id: x.id, production_completion_date: this.productionCompletionDateMultiple }, 'production-completion-date'));
      });
      const itemsRes = await Promise.all(items);
      this.$bus.$emit('loading');
      if (itemsRes.includes(false)) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.get();
    },

    subtractWeekdays(date, days) {
      const result = new Date(date);
      let remaining = days;

      while (remaining > 0) {
        result.setDate(result.getDate() - 1);
        const day = result.getDay();
        if (day !== 5 && day !== 6) {
          // eslint-disable-next-line no-plusplus
          remaining--;
        }
      }

      return result;
    },

    addWeekdays(date, days) {
      const result = new Date(date);
      let remaining = days;

      while (remaining > 0) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        if (day !== 5 && day !== 6) {
          // eslint-disable-next-line no-plusplus
          remaining--;
        }
      }

      return result;
    },

    async archiveAll() {
      const confirm = await this.$refs.confirmForm.open({
        // eslint-disable-next-line eqeqeq
        title: `Are you sure that you want to ${this.status == 1 ? 'ARCHIVE' : 'RESTORE'} all selected records?`,
      });
      if (!confirm) return;
      const requests = [];
      this.selectedItems.forEach((x) => {
        requests.push(this.$api.wipPanelSchedule.get(`toggle/${x.id}/${x.status_id}`));
      });

      const res = await Promise.all(requests);
      if (res.includes(false)) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    tabChange(item) {
      if (this.selectedTab === item) {
        this.selectedTab = null;
        this.filterJobSubClass = null;
        this.filterLocationId = null;
        this.get();
        // this.getWindowAccuracy();
        this.storeState('selectedTab', null);
        return;
      }
      this.selectedTab = item;
      if (item.type === 'location') {
        this.filterLocationId = item.id;
        // const jobSubClass4800Windows = 1;
        // const tab300Chrislea = 2;
        // if (item.id === tab300Chrislea) {
        //   this.filterJobSubClass = jobSubClass4800Windows;
        // } else { this.filterJobSubClass = null; }
      }
      this.storeState('selectedTab', item);
      this.get();
      // this.getWindowAccuracy();
    },

    openFinishedGoods() {
      this.$refs.finishedGoodGroupedForm.open();
    },

    async sendEmailPdf() {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to send an email containing the latest Production Schedule reports?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.wipPanelSchedule.get('send-email-pdf');
      this.$bus.$emit('loading');
      if (res) {
        this.$bus.$emit('showSuccess');
      } else {
        this.$bus.$emit('showError');
      }
    },

    checkScroll(event) {
      const bottomOfTable = (event.target.scrollHeight < event.target.scrollTop + event.target.clientHeight + 5 && event.target.scrollHeight > event.target.scrollTop + event.target.clientHeight - 5) || event.target.scrollHeight === event.target.scrollTop + event.target.clientHeight;
      if (bottomOfTable) {
        this.items = this.allItems.slice(0, this.items.length + 100);
      }
    },

    isJobFinished(item) {
      if (item.is_shipping === 1) {
        return true;
      }
      return false;
    },

    isJobShipped(item) {
      if (item.is_received === 1) {
        return true;
      }
      return false;
    },

    formatLocation(location) {
      const [num, word] = location.trim().split(' ');
      return `${num} ${word.slice(0, 2)}`;
    },

    delay(item) {
      this.$refs.delayReasonForm.open(item);
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
      this.storeState('pagination', newOptions);
    },

    // getMinDate(multiple = false) {
    //   // eslint-disable-next-line eqeqeq
    //   if (this.status != this.statusIdOnHand) return this.today;

    //   let item = null;

    //   if (multiple) {
    //     if (!this.selectedItems || this.selectedItems.length !== 1) return this.dayAfterSix;
    //     // eslint-disable-next-line prefer-destructuring
    //     item = this.selectedItems[0];
    //   } else {
    //     if (!this.selectedItem) return this.dayAfterSix;
    //     item = this.selectedItem;
    //   }

    //   if (!item.job) return this.dayAfterSix;
    //   const subclassIdCornerPost = 2;
    //   if (item.job.sub_class_id === subclassIdCornerPost || item.job.reference.includes('BS')) {
    //     return this.today;
    //   }
    //   return this.dayAfterSix;
    // },

    getStageClass(item, stage) {
      const itemClassName = item.class ? item.class.name : '';
      switch (stage.statusId) {
        case this.glassStatusIdNew || this.glassStatusIdIssued:
          if (item.total_new !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1) return 'green-box';
          return 'empty-box';
        case this.glassStatusIdCutting:
          if (item.total_cutting !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new !== 0) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdTempering:
          if (item.total_tempering !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0)) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdProduced:
          //this is under SHP header
          if (this.customPanelWorkflow4800 && itemClassName.includes('4800') || this.customPanelWorkflow6000 && itemClassName.includes('6000')) {
            return 'empty-box';
          }
          if (item.total_produced !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0)) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdShipped:
          if (this.customPanelWorkflow4800 && itemClassName.includes('4800') || this.customPanelWorkflow6000 && itemClassName.includes('6000')) {
            return 'empty-box';
          }
          // eslint-disable-next-line no-case-declarations
          const total = item.total_received + item.total_shipped_to_site + item.total_received_on_site;
          if (total !== 0 && item.wip_panel_quantity !== 0 && total === item.wip_panel_quantity) return 'green-box';
          if (item.total_shipped !== 0 || item.total_received !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0 && item.total_produced === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0 || item.total_produced !== 0)) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdReceived:
          if (this.customPanelWorkflow4800 && itemClassName.includes('4800') || this.customPanelWorkflow6000 && itemClassName.includes('6000')) {
            return 'empty-box';
          }
          if (item.total_received !== 0 && item.total_shipped_to_site !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_received === 0 && item.total_new === 0 && item.total_cutting === 0 && item.total_produced === 0 && item.total_shipped === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0 || item.total_produced !== 0 || item.total_received !== 0) && item.total_shipped_to_site !== 0) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdShippedToSite:
          if (this.customPanelWorkflow4800 && itemClassName.includes('4800') || this.customPanelWorkflow6000 && itemClassName.includes('6000')) {
            return 'empty-box';
          }
          if (item.total_received_on_site !== 0 && item.wip_panel_quantity !== 0 && item.total_received_on_site === item.wip_panel_quantity) return 'green-box';
          if (item.total_shipped_to_site !== 0 || item.total_received_on_site !== 0) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdRejected:
          if (item.total_rejected !== 0) return 'red-box';
          return 'empty-box';
        default:
          return 'empty-box';
      }
    },

    getStageValue(item, stage) {
      const itemClassName = item.class ? item.class.name : '';
      switch (stage.statusId) {
        case this.glassStatusIdNew || this.glassStatusIdIssued:
          if (item.total_new !== 0) return item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1) return stage.letter;
          return '';
        case this.glassStatusIdCutting:
          if (item.total_cutting !== 0) return item.total_cutting + item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0) return stage.letter;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new !== 0) return item.total_new;
          return '';
        case this.glassStatusIdProduced:
          if (this.customPanelWorkflow4800 && itemClassName.includes('4800') || this.customPanelWorkflow6000 && itemClassName.includes('6000')) {
            return '';
          }
          if (item.total_produced !== 0) return item.total_produced + item.total_cutting + item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0) return stage.letter;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0)) return item.total_cutting + item.total_new;
          return '';
        case this.glassStatusIdShipped:
          if (this.customPanelWorkflow4800 && itemClassName.includes('4800') || this.customPanelWorkflow6000 && itemClassName.includes('6000')) {
            return '';
          }
          // eslint-disable-next-line no-case-declarations
          const total = item.total_received + item.total_shipped_to_site + item.total_received_on_site;
          if (total !== 0 && item.wip_panel_quantity !== 0 && total === item.wip_panel_quantity) return stage.letter;
          if (item.total_shipped !== 0 || item.total_received !== 0) return item.total_received + item.total_shipped + item.total_produced + item.total_cutting + item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0 && item.total_produced === 0) return stage.letter;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0 || item.total_produced !== 0)) return item.total_produced + item.total_cutting + item.total_new;
          return '';
        case this.glassStatusIdReceived:
          if (this.customPanelWorkflow4800 && itemClassName.includes('4800') || this.customPanelWorkflow6000 && itemClassName.includes('6000')) {
            return '';
          }
          if (item.total_received !== 0 && item.total_shipped_to_site !== 0) return item.total_shipped + item.total_produced + item.total_cutting + item.total_new + item.total_received;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_received === 0 && item.total_new === 0 && item.total_cutting === 0 && item.total_produced === 0 && item.total_shipped === 0) return stage.letter;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0 || item.total_produced !== 0 || item.total_received !== 0)  && item.total_shipped_to_site !== 0) return item.total_produced + item.total_cutting + item.total_new + item.total_received;
          return '';
        case this.glassStatusIdShippedToSite:
          if (this.customPanelWorkflow4800 && itemClassName.includes('4800') || this.customPanelWorkflow6000 && itemClassName.includes('6000')) {
            return '';
          }
          if (item.total_received_on_site !== 0 && item.wip_panel_quantity !== 0 && item.total_received_on_site === item.wip_panel_quantity) return stage.letter;
          if (item.total_shipped_to_site !== 0 || item.total_received_on_site !== 0) return item.total_received_on_site + item.total_shipped_to_site + item.total_received + item.total_shipped + item.total_produced + item.total_cutting + item.total_new;
          return '';
        default:
          return '';
      }
    },

    //if the status of the production schedule is greater than the stage status, return 1 else return 0
    getStatusValue(statusId, itemStatusId) {
      const statusesInOrder = [
        this.glassStatusIdNew,
        this.glassStatusIdCutting,
        this.glassStatusIdTempering,
        this.glassStatusIdInProduction,
        this.glassStatusIdProduced,
        this.glassStatusIdShipped,
        this.glassStatusIdPShipped,
        this.glassStatusIdReceived,
        this.glassStatusIdPReceived,
        this.glassStatusIdShippedToSite,
        this.glassStatusIdPShippedToSite,
        this.glassStatusIdReceivedOnSite,
        this.glassStatusIdPReceivedOnSite,
      ];

      const statusIndex = statusesInOrder.findIndex((x) => x === statusId);
      const itemStatusIndex = statusesInOrder.findIndex((x) => x === itemStatusId);

      return statusIndex < itemStatusIndex ? 1 : 0;
    },

    renderDoneButton(item) {
      const hasAccess =
        this.roles.includes(this.userRoleIdAdmin) ||
        this.roles.includes(this.userRoleIdPanelAdmin);

      const itemClassName = item.class ? item.class.name : '';

      const doneOnProduced =
        (itemClassName.includes('4800') && this.customPanelWorkflow4800) ||
        (itemClassName.includes('6000') && this.customPanelWorkflow6000);

      let isCompleted = false;

      if (doneOnProduced) {
        isCompleted = item.total_produced == item.wip_panel_quantity;
      } else {
        isCompleted =
          item.wip_panel_quantity == item.total_received ||
          item.wip_panel_quantity == item.total_received_on_site;
      }

      const validStatus =
        item.status_id === this.statusIdInProgress ||
        item.status_id === this.statusIdOnHand;

      return isCompleted && validStatus && hasAccess;
    },
  },
};
</script>

<style scoped>

#cellOverflow {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  min-width: 120px  !important;
  border-left: 1px solid #E0E0E0;
  background-color: #FAFAFA;

}

#cellOverflow.theme--dark {
  background-color: #323232;
}

span
{
  font-size: 12px !important;
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  background-color: #323232;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th > span {
  color: #FFFFFF;
}

::v-deep .theme--light.v-divider {
    border-color: rgba(0,0,0,0.4) !important;
    border: 1px solid rgba(0,0,0,0.4) !important;
}

:v-deep .v-btn__content
{
  color: white !important;
}

.box
{
  border-radius: 4px;
   width: 25px;
    height: 25px;
}

.empty-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFFFFF;
}

.empty-box span
{
  color: #000000;
}

.red-box
{
  border: 1.5px solid #F44336;
  background-color: #F44336;
}

.blue-box
{
  border: 1.5px solid #2196F3;
  background-color: #2196F3;
}

.yellow-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFD84D;
}

.yellow-box span
{
  color: #000000;
}

.green-box
{
  border: 1.5px solid #4CAF50;
  background-color: #4CAF50;
}

.green-box span
{
  color: #FFFFFF;
}
</style>
